"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Income = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _basis = require("basis");

var _components = require("../components");

var _hooks = require("../hooks");

var _types = require("../types");

var _styled = _interopRequireDefault(require("../theme/styled"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Wrapper = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  visibility: ", ";\n"])), function (p) {
  return p.complete ? 'hidden' : 'visible';
});

var Income = function Income() {
  var onEvent = (0, _hooks.useOnEvent)();
  var trackEvent = (0, _hooks.useEventTracker)();

  var _useContextSelector = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.state;
  }),
      incomeAccountData = _useContextSelector.incomeAccountData,
      selectedAccounts = _useContextSelector.selectedAccounts,
      institution = _useContextSelector.institution,
      enableNoneAreMyIncome = _useContextSelector.enableNoneAreMyIncome,
      enableTotalIncomeNotShown = _useContextSelector.enableTotalIncomeNotShown;

  var institutionSlug = (institution === null || institution === void 0 ? void 0 : institution.slug) || '';

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      complete = _useState2[0],
      setComplete = _useState2[1];

  var _useSelectedIncome = (0, _hooks.useSelectedIncome)(institutionSlug, selectedAccounts || []),
      submitSelectedIncomeRequest = _useSelectedIncome.request,
      loading = _useSelectedIncome.loading,
      error = _useSelectedIncome.error;

  var submitIncome = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(income, status, totalIncomeNotShownSelected) {
      var action, outcome, failure;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (submitSelectedIncomeRequest) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              action = 'poi-income-selection';

              if (status === _types.FiConnectEventCompleteStatus.NO_INCOME_FOUND) {
                action = 'poi-noincomefound-documentupload';
              }

              if (status === _types.FiConnectEventCompleteStatus.NO_INCOME_SELECTED) {
                action = 'poi-noincomeselected-documentupload';
              }

              trackEvent({
                action: action,
                label: 'income.buttonSubmit'
              }, {
                totalIncomeNotShownSelected: totalIncomeNotShownSelected,
                numberOfTransactionsSelected: income.length
              });
              _context.next = 8;
              return submitSelectedIncomeRequest(income);

            case 8:
              outcome = _context.sent;
              // Handle error response
              failure = outcome;

              if (!failure.error) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return");

            case 12:
              setComplete(true);
              onEvent({
                type: _types.FiConnectEventTypes.COMPLETE,
                status: status
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(), [submitSelectedIncomeRequest, trackEvent, onEvent]);

  var handleSubmitIncome = function handleSubmitIncome(income, totalIncomeNotShownSelected) {
    var status = income.length ? _types.FiConnectEventCompleteStatus.INCOME_SELECTED : _types.FiConnectEventCompleteStatus.NO_INCOME_SELECTED;
    void submitIncome(income, status, totalIncomeNotShownSelected);
  };
  /*
    User has selected accounts and no income was found
    We automatically submit an empty array to submitSelectedIncome
  */


  (0, _react.useEffect)(function () {
    if (!incomeAccountData) {
      void submitIncome([], _types.FiConnectEventCompleteStatus.NO_INCOME_FOUND, false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  if (!institution || !incomeAccountData) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    complete: complete
  }, /*#__PURE__*/_react.default.createElement(_basis.Container, null, /*#__PURE__*/_react.default.createElement(_components.Header, {
    error: error === null || error === void 0 ? void 0 : error.error
  }, /*#__PURE__*/_react.default.createElement(_components.TextContent, {
    path: "income.textTitle"
  })), /*#__PURE__*/_react.default.createElement(_basis.Container, {
    margin: "8 0 0 0"
  }, /*#__PURE__*/_react.default.createElement(_components.IncomeForm, {
    data: incomeAccountData,
    onSubmit: handleSubmitIncome,
    loading: loading,
    enableNoneAreMyIncome: enableNoneAreMyIncome,
    enableTotalIncomeNotShown: enableTotalIncomeNotShown
  })), /*#__PURE__*/_react.default.createElement(_components.LoginAgainButton, null)));
};

exports.Income = Income;